import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PersonUsesBookDto } from './person-uses-book.model';

export const PersonUsesBookActions = createActionGroup({
  source: 'PersonUsesBook API',
  events: {
    'Get Latest Person Uses Books': emptyProps(),
    'Get Latest Person Uses Books Success': props<{
      personUsesBooks: PersonUsesBookDto[];
    }>(),
    'Get Latest Person Uses Books Failure': props<{ error: Error }>(),
  },
});
